import React, {useEffect} from 'react';
import {Link, useHistory} from 'react-router-dom';
import logo from '../assets/images/logo.webp';
import UserService from "../services/UserService";


const NoRolesSideBar = (props) => {

    let history = useHistory();


    const logOut = () => {
        UserService.logout();
        history.push('/');
    };

    return (
        <div className="sidebar" data-color="purple" data-background-color="white">
            <div className="logo">
                <a
                    href="#"
                    className="simple-text logo-normal"
                    style={{marginRight: 75}}
                >
                    <img src={logo} width={120} alt="logo"/>
                </a>

            </div>
            <div id="sidebar" className="sidebar-wrapper ps-container ps-theme-default ">

                <ul className="nav aside_div scroll">
                    <li className="nav-item active">
                        <Link active-class="active" className="nav-link active" to="/home">
                            <i className="material-icons">dashboard</i>
                            <p>Home</p>
                        </Link>
                    </li>


                    <li className="nav-item">
                        <Link className="nav-link" onClick={logOut}>
                            <i className="fa fa-sign-out"/>
                            <p>Logout</p>
                        </Link>
                    </li>
                </ul>


                <div className="ps-scrollbar-x-rail" style={{left: 0, bottom: 0}}>
                    <div
                        className="ps-scrollbar-x"
                        tabIndex="0"
                        style={{left: 0, width: 0}}
                    />
                </div>
                <div className="ps-scrollbar-y-rail" style={{top: 0, right: 0}}>
                    <div
                        className="ps-scrollbar-y"
                        tabIndex={0}
                        style={{top: 0, height: 0}}
                    />
                </div>
            </div>
            <div className="sidebar-background"/>
        </div>
    )
}

export default NoRolesSideBar;
